import { ThemeProvider, CssBaseline } from "@mui/material";
import { AuthProvider } from "./auth/AuthContext";
import theme from "./core/theme";
import "./core/styles/global.css";

import AppRoutes from "./routes/AppRoutes";
import { AppSnackbar } from "./components";

// Import for Date Pickers
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function App() {
    return (
        <AuthProvider>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <AppSnackbar>
                        <AppRoutes />
                    </AppSnackbar>
                </LocalizationProvider>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;
